<!-- Apple-style Customer Login Container -->
<div class="apple-login-wrapper apple-fade-in">
  <div class="apple-container">
    <div class="apple-login-container">
      <!-- Login Card -->
      <div class="apple-card apple-login-card apple-slide-up">
        <!-- Header -->
        <div class="login-header">
          <div class="login-icon-wrapper">
            <mat-icon class="login-icon">person</mat-icon>
          </div>
          <h1 class="apple-heading-2">Kundenanmeldung</h1>
          <p class="apple-body-secondary">
            Melden Sie sich sicher über Microsoft an. Auf der Microsoft-Anmeldeseite können Sie Ihr Microsoft-Konto oder Ihre eigene E-Mail und Ihr Passwort verwenden.
          </p>
        </div>

        <!-- Content -->
        <div class="login-content" *ngIf="!isAuthenticated">
          <!-- Error Message -->
          <div class="apple-error-message" *ngIf="loginError">
            <mat-icon class="error-icon">error</mat-icon>
            <span class="apple-body">{{ loginError }}</span>
          </div>

          <!-- Sign-In Buttons -->
          <div class="login-actions">
            <button
              type="button"
              class="apple-button apple-button-primary apple-button-large"
              [disabled]="isLoading"
              (click)="login()">
              <mat-spinner *ngIf="isLoading" diameter="20" class="button-spinner"></mat-spinner>
              <mat-icon *ngIf="!isLoading">login</mat-icon>
              <span *ngIf="!isLoading">Kundenanmeldung</span>
              <span *ngIf="isLoading">Anmelden...</span>
            </button>

            <button
              type="button"
              class="apple-button apple-button-secondary apple-button-large"
              [disabled]="isLoading"
              (click)="loginEmployee()">
              <mat-icon>business</mat-icon>
              <span>Mitarbeiteranmeldung</span>
            </button>
          </div>

          <!-- Divider -->
          <div class="apple-divider">
            <span class="divider-text">oder</span>
          </div>

          <!-- Registration Info -->
          <div class="apple-info-card">
            <mat-icon class="info-icon">info_outline</mat-icon>
            <div class="info-content">
              <p class="apple-body-small"><strong>Noch kein Konto?</strong></p>
              <p class="apple-caption">
                Sie können ein Konto auf der Microsoft-Anmeldeseite erstellen (E-Mail + Passwort), nachdem Sie "Anmelden" ausgewählt haben.
              </p>
            </div>
          </div>
        </div>

        <!-- Authenticated State -->
        <div class="login-authenticated" *ngIf="isAuthenticated">
          <div class="success-icon-wrapper">
            <mat-icon class="success-icon">check_circle</mat-icon>
          </div>
          <h2 class="apple-heading-3">Willkommen zurück!</h2>
          <p class="apple-body-secondary">Sie sind bereits angemeldet. Weiterleitung zu Ihrem Dashboard...</p>
        </div>

        <!-- Footer Actions -->
        <div class="login-footer">
          <button
            class="apple-button apple-button-text"
            (click)="goBack()"
            [disabled]="isLoading">
            <mat-icon>arrow_back</mat-icon>
            <span>Zurück zu Anmeldeoptionen</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
